export const getTableFiltersParam = () => {
  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);
  const tableFilters = urlParams.get("tableFilters");

  return tableFilters ? JSON.parse(tableFilters) : [];
};
